import React from "react";
import "../../css/Home.css";
import Hero from "../../components/Hero";
import Footer from "../../components/Footer";
import ProfileSection from "../../components/ProfileSection";
function Home() {
  return (
    <>
      <Hero />
      <ProfileSection />
      <Footer />
    </>
  );
}

export default Home;
